<template>
  <div class="container" v-if='showModule'>
    <Breakage
      :approvalParams = "approvalParams"
      v-if="moduleName === 'breakage'">
    </Breakage>
    <GoodsStore
      :approvalParams = "approvalParams"
      v-if="moduleName === 'goods' || moduleName === 'goods_base_audit' || moduleName === 'goods_rate' || moduleName === 'goods_base_rate_audit'">
    </GoodsStore>
    <PurcharsePlan
      :approvalParams = "approvalParams"
      v-if="isShowPurchasePlan">
    </PurcharsePlan>
    <Suppiler
      :approvalParams = "approvalParams"
      v-if="moduleName === 'store_supplier' || moduleName === 'supplier_base_audit'">
    </Suppiler>
    <SalePrice
      :approvalParams = "approvalParams"
      v-if="moduleName === 'sale_price' || moduleName === 'sale_price_multi'">
    </SalePrice>
    <SaleStoreCancel
      :approvalParams = "approvalParams"
      v-if="moduleName === 'sale_store_cancel' ">
    </SaleStoreCancel>
    <PurcharseInspectionReject
      :approvalParams = "approvalParams"
      v-if="moduleName === 'single_inspect_reject' "/>
    <PurcharseReceiptReject
      :approvalParams = "approvalParams"
      v-if="moduleName === 'single_receipt_reject' || moduleName === 'receipt_tax_rate' ||  moduleName === 'receipt_tax_rate_reject'"/>
    <Unqualified
      :approvalParams = "approvalParams"
      v-if="moduleName === 'unqualified'">
    </Unqualified>
    <SaleRecallPlan
      :approvalParams = "approvalParams"
      v-if="moduleName === 'sale_recall_plan'">
    </SaleRecallPlan>
    <StocktakingAdjust
      :approvalParams = "approvalParams"
      v-if="moduleName === 'stocktaking_adjust' || moduleName === 'stocktaking_no_inventory_adjust'">
    </StocktakingAdjust>
    <SaleRefund
      :approvalParams = "approvalParams"
      v-if="moduleName === 'sale_refund_audit'">
    </SaleRefund>
    <AdvancesRefund
      :approvalParams = "approvalParams"
      v-if="moduleName === 'finance_deposit_refund'">
    </AdvancesRefund>
    <SupplierRefundFlow
      :approvalParams = "approvalParams"
      v-if="moduleName === 'purchase_refund'">
    </SupplierRefundFlow>
    <PromoteSales
      :approvalParams = "approvalParams"
      v-if="moduleName === 'promote_sales' || moduleName === 'all_promote_sales'">
    </PromoteSales>
    <payableAndCostChangeBill
      :approvalParams = "approvalParams"
      v-if="moduleName === 'single_finance_payable' || moduleName === 'single_finance_payable_cancel'">
    </payableAndCostChangeBill>
    <!-- <Prescription :approvalParams = "approvalParams"></Prescription> -->
    <DestroyFlow :approvalParams = "approvalParams"
       v-if="moduleName === 'destroy'"></DestroyFlow>
    <returnProfit :approvalParams="approvalParams" v-if="moduleName === 'finance_rebate'"></returnProfit>
    <Payment :approvalParams = "approvalParams" v-if="moduleName === 'single_finance_payment'"></Payment>
    <receiveLimit :approvalParams = "approvalParams" v-if="moduleName === 'receivable_limit'"></receiveLimit>
    <supplierRefund :approvalParams="approvalParams" v-if="moduleName === 'purchase_refund_cancel'"></supplierRefund>
    <AdvancesRefund
      :approvalParams = "approvalParams"
      v-if="moduleName === 'advances_refund_audit'">
    </AdvancesRefund>
  </div>
</template>

<script>
import Breakage from './pages/Breakage.vue';
import GoodsStore from './pages/GoodsStore.vue';
import PurcharsePlan from './pages/PurcharsePlan.vue';
import Suppiler from './pages/Suppiler.vue';
import SalePrice from './pages/PriceFlowInfo.vue';
import SaleStoreCancel from './pages/CancelOrderFlowInfo.vue';
import PurcharseInspectionReject from './pages/PurcharseInspectionReject.vue';
import PurcharseReceiptReject from './pages/PurcharseReceiptReject.vue';
import Unqualified from './pages/Unqualified.vue';
import SaleRecallPlan from './pages/SaleRecallPlan.vue';
import StocktakingAdjust from './pages/StocktakingAdjust.vue';
import SupplierRefundFlow from './pages/SupplierRefundFlow.vue';
import PromoteSales from './pages/PromoteSales.vue';
import payableAndCostChangeBill from './pages/payableAndCostChangeBill.vue';
import SaleRefund from './pages/SaleRefund.vue';
// import Prescription from './pages/Prescription.vue';// 暂时取消修改处方审批
import DestroyFlow from './pages/DestroyFlow.vue';
import returnProfit from './pages/returnProfit.vue';
import Payment from './pages/Payment.vue';
import receiveLimit from './pages/receiveLimit.vue';
import supplierRefund from './pages/supplierRefund.vue';
import AdvancesRefund from './pages/AdvancesReceivedRefund.vue';


export default {
  components: {
    Breakage,
    GoodsStore,
    PurcharsePlan,
    Suppiler,
    SalePrice,
    SaleStoreCancel,
    PurcharseInspectionReject,
    PurcharseReceiptReject,
    Unqualified,
    SaleRecallPlan,
    StocktakingAdjust,
    SaleRefund,
    SupplierRefundFlow,
    payableAndCostChangeBill,
    // Prescription,
    DestroyFlow,
    Payment,
    returnProfit,
    PromoteSales,
    receiveLimit,
    supplierRefund,
    AdvancesRefund,
  },
  computed: {
    isShowPurchasePlan() {
      const moduleNameList = ['single_purchase_plan', 'single_purchase_plan_daily', 'single_purchase_plan_month', 'single_purchase_plan_quarter', 'single_purchase_plan_quick_daily'];
      return moduleNameList.includes(this.moduleName);
    },
  },
  watch: {
    $route: {
      handler(val) {
        console.log(val);
        this.showModule = false;
        this.$nextTick(() => {
          this.init();
          this.showModule = true;
        });
      },
      deep: true,
    },
  },
  data() {
    return {
      showModule: true,
      moduleName: '',
      approvalParams: {},
    };
  },
  methods: {
    init() {
      this.moduleName = decodeURIComponent(this.$route.params.businessType);
      this.approvalParams = {
        node: this.$route.params.node,
        workNo: decodeURIComponent(this.$route.params.workNo),
        businessUrl: decodeURIComponent(this.$route.params.businessUrl),
        businessId: decodeURIComponent(this.$route.params.businessId),
        endStatus: decodeURIComponent(this.$route.params.endStatus),
        moduleName: this.moduleName,
        approvalTabStatus: this.$route.params.approvalTabStatus,
      };
    },

  },
  created() {
    this.init();
  },

};
</script>
